export default {"src":"/_next/static/media/aurora-explorer.cbb71842.svg","height":808,"width":808,"blurWidth":0,"blurHeight":0};